import React, { useState, useEffect } from "react";
import { Form, Col, InputGroup, Button, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../redux/slice/userSlice";
import myApi from "../utils/apiActions/myApi";
import { baseUrl } from "../utils/apiActions/dashboardApi";
import { toastError, toastSuccess } from "../utils/toastrResponse";

function Login() {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [type, setType] = useState(true);
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [userName, setUserName] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.removeItem("user");
    localStorage.removeItem("acces_token");
  }, []);
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    myApi
      .post(`${baseUrl}/users/login`, {
        username: form.elements.email.value,
        password: form.elements.password.value,
      })
      .then((res) => {
        dispatch(setUserDetails(res.data.user));
        const allRoles = res.data.groups.map((group) => group.roles).flat();
        const user = {
          access_token: res.data.accessToken,
          name: `${res.data.user.firstName} ${res.data.user.lastName}`,
          username: res.data.user.username,
          roles: allRoles,
          // role:
          //   res.data.groups.length > 1
          //     ? res.data.groups[res.data.groups.length - 1].roles
          //     : res.data.groups[0]?.roles,
        };
        localStorage.setItem("username", res.data.user.username);
        localStorage.setItem(
          "locations",
          JSON.stringify(res.data.locations[res.data.locations.length - 1])
        );
        localStorage.setItem(
          "roles",
          JSON.stringify(allRoles)
        );
        localStorage.setItem(
          "agentLocations",
          JSON.stringify(res.data.locations)
        );
        console.log("loggedin user roles:", allRoles);
        localStorage.setItem("user", JSON.stringify(user));
        toastSuccess("Login successful");
        const redirectPath = localStorage.getItem("redirectPath");
        if (allRoles?.some((role) => role.id === 34)) {
          if (redirectPath) {
            localStorage.removeItem("redirectPath");
            navigate(redirectPath);
          } else {
            navigate("/loggedin/low-level-dashboard");
          }
        } else if (allRoles?.some((role) => role.id === 36)) {
          if (redirectPath) {
            localStorage.removeItem("redirectPath");
            navigate(redirectPath);
          } else {
            navigate("/loggedin/top-level-dashboard");
          }
        } else {
          if (redirectPath) {
            localStorage.removeItem("redirectPath");
            navigate(redirectPath);
          } else {
            navigate("/loggedin/search-accounts");
          }
        }
      })
      .catch((err) => {
        toastError(err);
      });

    setValidated(true);
  };
  // Resetpassword
  const resetPassword = (e) => {
    e.preventDefault();
    const url = `${baseUrl}/users/${userName}/resetpassword`;
    fetch(url, {
      method: "POST",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => {
        if (res.ok) {
          toastSuccess(
            `Password reset successfully, check sms sent to +${userName}`
          );
          setShow(false);
        } else {
          toastError("Could not reset password, contact system administrator");
        }
        return res.json();
      })
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className='col-xl-12 col-md-12 login-Wrap'>
      <div className='ms-panel ms-panel-fh'>
        <div className='ms-panel-header'>
          <h6>{"Login"}</h6>
        </div>
        <div className='ms-panel-body'>
          <Form validated={validated} onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} md='12' className='mb-3' controlId='email'>
                <Form.Label>Username</Form.Label>
                <InputGroup>
                  <Form.Control required type='text' placeholder='Username' />
                  <Form.Control.Feedback type='invalid'>
                    Please provide a valid email.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
              <Form.Group
                as={Col}
                md='12'
                className='mb-2'
                controlId='password'
              >
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <div style={{ width: "100%", position: "relative" }}>
                    <Form.Control
                      required
                      type={type ? "password" : "text"}
                      placeholder='Password'
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {password.length > 0 && (
                      <i
                        className='fa fa-eye'
                        aria-hidden='true'
                        style={{
                          position: "absolute",
                          right: 15,
                          bottom: 8,
                          cursor: "pointer",
                          fontSize: 20,
                          color: "#0000ff",
                        }}
                        onClick={() => setType(!type)}
                      />
                    )}
                  </div>
                  <Form.Control.Feedback type='invalid'>
                    Please provide a password.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Form.Row>
            <div
              className='d-flex justify-content-end'
              style={{ marginTop: -20 }}
            >
              <p className='reset-password' onClick={() => setShow(true)}>
                Forgot Password? reset it here
              </p>
            </div>
            <div className='d-flex justify-content-center'>
              <u style={{ color: "#357ffa" }}>
                <p style={{ cursor: "pointer", color: "#357ffa" }}>
                  <Link
                    to='/terms'
                    target='_blank'
                    style={{ color: "#124db1" }}
                  >
                    Terms And Conditions
                  </Link>
                </p>
              </u>
            </div>
            <Button
              type='submit'
              className='mt-4 d-block w-100 custom-btn-color'
            >
              Sign In
            </Button>
          </Form>
        </div>
      </div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={() => setShow(false)}>
          <h5>Reset Password</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Form onSubmit={resetPassword}>
            <input
              placeholder='Username yawe ex:250783458910'
              className='form-control input-select mb-2'
              name='userName'
              onChange={(e) => setUserName(e.target.value)}
              required
            />

            <div className='d-flex justify-content-center mt-2'>
              <Button type='submit' className='custom-btn-color'>
                Reset
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Login;
